/* global $ */
import css from './styles.scss'
import template from './template.html'

export default [directive]

const localClassName = css['paste-options']

function directive() {
  return {
    require: '^composeBody',
    restrict: 'AE',
    replace: false,
    template: `<div data-container-id="{{vm.id}}" class="${localClassName}" ng-show="vm.isVisible" ng-class="{'${localClassName}': true, 'paste-options__with-menu': vm.isOpen}">${template}</div>`,
    link: function(scope, elem, attrs, controller) {
      const self = scope.vm
      self.id = `${localClassName}_${attrs.pasteOptions}`

      // pasteHolderFactory is disabled in composeBody
      // const pasteHolderFactory = controller.pasteHolderFactory
      // self.pasteHolderInstance = pasteHolderFactory(attrs.pasteOptions)

      // self.pasteHolderInstance.register({
      //   setVisible: (visible) => {
      //     self.setElementVisible(visible)
      //   },
      //   dismiss: () => {
      //     self.hidePopover()
      //     self.setElementVisible(false)
      //   }
      // })
    },
    controllerAs: 'vm',
    bindToController: true,
    controller: function() {
      this.isOpen = false
      this.isVisible = false

      this.setElementVisible = (visible) => {
        this.isVisible = visible
      }
      const popoverClass = () =>
        `[data-container-id="${this.id}"] .js-popover-spot`
      const hidePopover = (this.hidePopover = () => {
        if (!this.isOpen) {
          return
        }
        this.isOpen = false
        $(popoverClass()).popover('hide')
        $('body').off('click', hidePopover)
      })

      this.toggleMenu = () => {
        if (this.isOpen) {
          hidePopover()
        } else {
          this.isOpen = true

          const popoverElement = $(
            `[data-container-id="${this.id}"] .js-formatting-popover`
          )[0]
          $(popoverClass())
            .popover({
              content: popoverElement,
              html: true,
              container: 'body',
              placement: 'bottom',
              trigger: 'focus click',
            })
            .popover('show')
            .data('bs.popover')
            .tip.classList.add('popover--dark')
          $('body').on('click', hidePopover)
        }
      }

      this.pasteAsPlainText = ($event) => {
        $event.preventDefault()
        this.pasteHolderInstance && this.pasteHolderInstance.pasteAsPlainText()
      }

      this.pasteWithFormat = ($event) => {
        $event.preventDefault()
        this.pasteHolderInstance && this.pasteHolderInstance.pasteWithFormat()
      }

      this.$onDestroy = () => {
        this.pasteHolderInstance && this.pasteHolderInstance.register(null)
        hidePopover()
        $(popoverClass()).popover('destroy')
      }
    },
  }
}
